/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const tableStyleB = {
  borderCollapse: "collapse",
  width: "100%",
  marginTop: "20px",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, value: { price: 0 } },
  { id: 1, value: { price: 0 } },
  { id: 2, value: { price: 0 } },
  { id: 3, value: { price: 0 } },
  { id: 4, value: { price: 0 } },
  { id: 5, value: { price: 0 } },
  { id: 6, value: { price: 0 } },
  { id: 7, value: { price: 0 } },
  { id: 8, value: { price: 0 } },
  { id: 9, value: { price: 0 } },
  { id: 10, value: { price: 0 } },
  { id: 11, value: { price: 0 } },
  { id: 12, value: { price: 0 } },
  { id: 13, value: { price: 0 } },
  { id: 14, value: { price: 0 } },
  { id: 15, value: { price: 0 } },
  { id: 16, value: { price: 0 } },
  { id: 17, value: { price: 0 } },
  { id: 18, value: { price: 0 } },
  { id: 19, value: { price: 0 } },
  { id: 20, value: { price: 0 } },
  { id: 21, value: { name: "", price: 0 } },
  { id: 22, value: { price: 0 } },
  { id: 23, value: { price: 0 } },
  { id: 24, value: { price: 0 } },
  { id: 25, value: { price: 0 } },
  { id: 26, value: { price: 0 } },
  { id: 27, value: { price: 0 } },
  { id: 28, value: { price: 0 } },
  { id: 29, value: { price: 0 } },
  { id: 30, value: { price: 0 } },
  { id: 31, value: { price: 0 } },
  { id: 32, value: { price: 0 } },
  { id: 33, value: { price: 0 } },
  { id: 34, value: { price: 0 } },
  { id: 35, value: { price: 0 } },
  { id: 36, value: { price: 0 } },
  { id: 37, value: { price: 0 } },
  { id: 38, value: { price: 0 } },
  { id: 39, value: { price: 0 } },
  { id: 40, value: { price: 0 } },
  { id: 41, value: { price: 0 } },
  { id: 42, value: { price: 0 } },
  { id: 43, value: { price: 0 } },
  { id: 44, value: { price: 0 } },
  { id: 45, value: { price: 0 } },
  { id: 46, value: { price: 0 } },
  { id: 47, value: { price: 0 } },
  { id: 48, value: { price: 0 } },
  { id: 49, value: { price: 0 } },
  { id: 50, value: { price: 0 } },
  { id: 51, value: { price: 0 } },
  { id: 52, value: { price: 0 } },
  { id: 53, value: { price: 0 } },
  { id: 54, value: { price: 0 } },
  { id: 55, value: { price: 0 } },
  { id: 56, value: { price: 0 } },
  { id: 57, value: { price: 0 } },
  { id: 58, value: { price: 0 } },
  { id: 59, value: { price: 0 } },
  { id: 60, value: { price: 0 } },
  { id: 61, value: { price: 0 } },
  { id: 62, value: { price: 0 } },
  { id: 63, value: { price: 0 } },
  { id: 64, value: { price: 0 } },
  { id: 65, value: { price: 0 } },
  { id: 66, value: { price: 0 } },
  { id: 67, value: { price: 0 } },
  { id: 68, value: { price: 0 } },
  { id: 69, value: { price: 0 } },
  { id: 70, value: { price: 0 } },
  { id: 71, value: { price: 0 } },
  { id: 72, value: { price: 0 } },
  { id: 73, value: { price: 0 } },
];
const dataTableB = [
  { id: 0, value: { skkttk: 0, tm1052: 0, tm1056: 0, tm1057: 0, tm1099: 0, tm1053: 0 } },
  { id: 1, value: { skkttk: 0, tm1052: 0, tm1056: 0, tm1057: 0, tm1099: 0, tm1053: 0 } },
  { id: 2, value: { skkttk: 0, tm1052: 0, tm1056: 0, tm1057: 0, tm1099: 0, tm1053: 0 } },
  { id: 3, value: { skkttk: 0, tm1052: 0, tm1056: 0, tm1057: 0, tm1099: 0, tm1053: 0 } },
];
export default function Table({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [dataB, setDataB] = useState(dataTableB);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  const handleChangeB = (values) => {
    const { id, name, value } = values;

    setDataB((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(dataB);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"A"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Kết quả kinh doanh ghi nhận theo báo cáo tài chính"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"A"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Tổng lợi nhuận kế toán trước thuế thu nhập doanh nghiệp"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"A1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={1}
                  name="price"
                  value={data[1].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"B"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Xác định thu nhập chịu thuế theo Luật thuế thu nhập doanh nghiệp"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"B"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Điều chỉnh tăng tổng lợi nhuận trước thuế thu nhập doanh nghiệp (B1=B2+B3+B4+B5+B6+B7)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"B1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={3}
                  name="price"
                  readonly="true"
                  value={data[3].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Các khoản điều chỉnh tăng doanh thu"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={4}
                  name="price"
                  value={data[4].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Chi phí của phần doanh thu điều chỉnh giảm"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={5}
                  name="price"
                  value={data[5].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Các khoản chi không được trừ khi xác định thu nhập chịu thuế"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={6}
                  name="price"
                  value={data[6].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={7}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế thu nhập đã nộp cho phần thu nhập nhận được ở nước ngoài"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={7}
                  name="price"
                  value={data[7].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={8}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Điều chỉnh tăng lợi nhuận do xác định giá thị trường đối với giao dịch liên kết"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={8}
                  name="price"
                  value={data[8].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={9}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Các khoản điều chỉnh làm tăng lợi nhuận trước thuế khác"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={9}
                  name="price"
                  value={data[9].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={10}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {
                  "Điều chỉnh giảm tổng lợi nhuận trước thuế thu nhập doanh nghiệp (B8=B9+B10+B11+B12)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"B8"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={3}
                  name="price"
                  readonly="true"
                  value={data[3].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={11}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Giảm trừ các khoản doanh thu đã tính thuế năm trước"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B9"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={11}
                  name="price"
                  value={data[11].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={12}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Chi phí của phần doanh thu điều chỉnh tăng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B10"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={12}
                  name="price"
                  value={data[12].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={13}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {
                  "Chi phí lãi vay không được trừ kỳ trước được chuyển sang kỳ này của doanh nghiệp có giao dịch liên kết"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B11"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={13}
                  name="price"
                  value={data[13].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={14}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Các khoản điều chỉnh làm giảm lợi nhuận trước thuế khác"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B12"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={14}
                  name="price"
                  value={data[14].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={15}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Tổng thu nhập chịu thuế (B13=A1+B1B8)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"B13"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={15}
                  name="price"
                  readonly="true"
                  value={data[15].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={16}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"3.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thu nhập chịu thuế từ hoạt động sản xuất kinh doanh"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"B14"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={16}
                  name="price"
                  value={data[16].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={17}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thu nhập chịu thuế từ hoạt động chuyển nhượng bất động sản"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"B15"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={17}
                  name="price"
                  readonly="true"
                  value={data[17].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={18}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"C"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Thuế thu nhập doanh nghiệp (TNDN) phải nộp từ hoạt động sản xuất kinh doanh"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr key={19}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thu nhập chịu thuế (C1=B14)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={19}
                  name="price"
                  value={data[19].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={20}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thu nhập miễn thuế"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={20}
                  name="price"
                  value={data[20].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={21}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable2
                  id={21}
                  name="name"
                  value={data[21].value.name}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
            </tr>
            <tr key={22}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Chuyển lỗ và bù trừ lãi, lỗ (C3=C3a+C3b)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={22}
                  name="price"
                  readonly="true"
                  value={data[22].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={23}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Trong đó:"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
            </tr>
            <tr key={24}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Lỗ từ hoạt động SXKD được chuyển trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C3a"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={24}
                  name="price"
                  readonly="true"
                  value={data[24].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={25}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Lỗ từ chuyển nhượng BĐS được bù trừ với lãi của hoạt động SXKD"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C3b"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={25}
                  name="price"
                  readonly="true"
                  value={data[25].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={26}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thu nhập tính thuế (TNTT) (C4=C1-C2-C3)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={26}
                  name="price"
                  readonly="true"
                  value={data[26].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={27}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Trích lập quỹ khoa học công nghệ (nếu có)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={27}
                  name="price"
                  value={data[27].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={28}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"TNTT sau khi đã trích lập lũy khoa học công nghệ (C6=C4-C5=C7+C8)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={28}
                  name="price"
                  readonly="true"
                  value={data[28].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={29}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Trong đó:"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
            </tr>
            <tr key={30}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"6.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thu nhập tính thuế áp dụng thuế suất 20%"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={30}
                  name="price"
                  value={data[30].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={31}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"6.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thu nhập tính thuế tính theo thuế suất không ưu đãi khác"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C8"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={31}
                  name="price"
                  value={data[31].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={32}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"6.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế suất không ưu đãi khác (%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C9"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={32}
                  name="price"
                  value={data[32].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={33}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Thuế TNDN từ hoạt động SXKD tính theo thuế suất không ưu đãi (C9=(C7x20%)+(C8xC8a))"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C9"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={33}
                  name="price"
                  readonly="true"
                  value={data[33].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={34}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"8"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN được ưu đãi theo Luật thuế TNDN (C10=C11+C12+C13)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C10"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={34}
                  name="price"
                  readonly="true"
                  value={data[34].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={35}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Trong đó:"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
            </tr>
            <tr key={36}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"8.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN chênh lệch do áp dụng mức thuế suất ưu đãi"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C11"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={36}
                  name="price"
                  readonly="true"
                  value={data[36].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={37}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"8.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN được miễn trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C12"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={37}
                  name="price"
                  readonly="true"
                  value={data[37].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={38}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"8.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN được giảm trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C13"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={38}
                  name="price"
                  readonly="true"
                  value={data[38].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={39}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"9"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN được miễn, giảm theo Hiệp định thuế"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C14"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={39}
                  name="price"
                  value={data[39].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={40}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"10"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN được miễn, giảm theo từng thời kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"C15"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={40}
                  name="price"
                  value={data[40].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={41}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"11"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế thu nhập đã nộp ở nước ngoài được trừ trong kỳ tính thuế"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C16"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={41}
                  name="price"
                  readonly="true"
                  value={data[41].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={42}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"12"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN phải nộp của hoạt động sản xuất kinh doanh (C17=C9-C10-C14-C15-C16)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"C17"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={42}
                  name="price"
                  readonly="true"
                  value={data[42].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={43}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"D"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN phải nộp từ hoạt động chuyển nhượng BĐS"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"D"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr key={44}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thu nhập chịu thuế (D1=B15)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"D1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={44}
                  name="price"
                  readonly="true"
                  value={data[44].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={45}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Lỗ từ hoạt động chuyển nhượng BĐS được chuyển trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"D2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={45}
                  name="price"
                  value={data[45].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={46}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thu nhập tính thuế (D3=D1-D2)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"D3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={46}
                  name="price"
                  readonly="true"
                  value={data[46].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={47}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Trích lập quỹ khoa học công nghệ (nếu có)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"D4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={47}
                  name="price"
                  value={data[47].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={48}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"TNTT sau khi đã trích lập quỹ khoa học công nghệ (D5=D3-D4)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"D5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={48}
                  name="price"
                  readonly="true"
                  value={data[48].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={49}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN phải nộp của hoạt động chuyển nhượng BĐS trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"D6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={49}
                  name="price"
                  value={data[49].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={50}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN chênh lệch do áp dụng mức thuế suất ưu đãi đối với thu nhập từ thực hiện dự án đầu tư " +
                  "- kinh doanh nhà ở xã hội để bán, cho thuê, cho thuê mua"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"D7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={50}
                  name="price"
                  value={data[50].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={51}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"8"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN của hoạt động chuyển nhượng BĐS còn phải nộp kỳ này (D8=D6-D7)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"D8"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={51}
                  name="price"
                  readonly="true"
                  value={data[51].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={52}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"E"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Số thuế TNDN phải nộp quyết toán trong kỳ (E=E1+E2+E5)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"E"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={54}
                  name="price"
                  readonly="true"
                  value={data[52].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={53}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN của hoạt động sản xuất kinh doanh"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"E1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={53}
                  name="price"
                  value={data[53].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={54}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN từ hoạt động chuyển nhượng BĐS (E2=E3+E4)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"E2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={54}
                  name="price"
                  readonly="true"
                  value={data[54].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={55}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN từ hoạt động chuyển nhượng bất động sản"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"E3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={55}
                  name="price"
                  value={data[55].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={56}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN từ hoạt động chuyển nhượng cơ sở hạ tầng, nhà có thu tiền theo tiến độ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"E4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={56}
                  name="price"
                  value={data[56].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={57}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN phải nộp khác (nếu có)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"E5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={57}
                  name="price"
                  value={data[57].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={58}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Trong đó thuế TNDN từ xử lý Quỹ phát triển khoa học công nghệ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"E6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={58}
                  name="price"
                  readonly="true"
                  value={data[58].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={59}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"G"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Số tiền TNDN đã tạm nộp (G=G1+G2+G3+G4+G5)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"G"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={59}
                  name="price"
                  readonly="true"
                  value={data[59].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={60}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN đã tạm nộp của hoạt động sản xuất kinh doanh"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={60}
                  name="price"
                  readonly="true"
                  value={data[60].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={61}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"G1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={61}
                  name="price"
                  value={data[61].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={62}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN đã tạm nộp trong năm"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"G2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={62}
                  name="price"
                  value={data[62].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={63}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN đã tạm nộp của hoạt động chuyển nhượng BĐS"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={63}
                  name="price"
                  readonly="true"
                  value={data[63].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={64}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này của hoạt động chuyển nhượng BĐS"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"G3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={64}
                  name="price"
                  value={data[64].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={65}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Thuế TNDN đã tạm nộp trong năm của hoạt động chuyển nhượng BĐS"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"G4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={65}
                  name="price"
                  value={data[65].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={66}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {
                  "Thuế TNDN đã tạm nộp các kỳ trước và trong năm quyết toán của hoạt động chuyển nhượng cơ sở hạ tầng, nhà có thu tiền theo tiến độ"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"G5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={66}
                  name="price"
                  value={data[66].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={67}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"H"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"H"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr key={68}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm của hoạt động sản xuất kinh doanh (H1=E1+E5-G2)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"H1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={68}
                  name="price"
                  readonly="true"
                  value={data[68].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={69}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm của hoạt động chuyển nhượng BĐS (H2=E3-G4)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"H2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={69}
                  name="price"
                  readonly="true"
                  value={data[69].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={70}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp của hoạt động chuyển nhượng cơ sở hạ tầng, nhà có thu tiền theo tiến độ (H3=E4-G5)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"H3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={70}
                  name="price"
                  readonly="true"
                  value={data[70].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={71}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"I"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {
                  "Số thuế TNDN còn phải nộp đến thời hạn nộp hồ sơ khai quyết toán thuế (I=E-G=I1+I2)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                {"I"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={71}
                  name="price"
                  readonly="true"
                  value={data[71].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={72}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN còn phải nộp của hoạt động sản xuất kinh doanh (I1=E1+E5-G1-G2)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"I1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={72}
                  name="price"
                  readonly="true"
                  value={data[72].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={73}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Thuế TNDN còn phải nộp của hoạt động chuyển nhượng BĐS (I2=G3-G4-G5)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"I2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={73}
                  name="price"
                  readonly="true"
                  value={data[73].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <table style={tableStyleB}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>E</Th>
              <Th style={{ textAlign: "center", maxWith: 70 }}>
                Số thuế TNDN phải nộp quyết toán trong kỳ (E=E1+E2+E5)
              </Th>
              <Th style={{ textAlign: "center" }}>E</Th>
              <Th style={{ textAlign: "center" }}>Số kê khai trên tờ khai</Th>
              <Th style={{ textAlign: "center" }}>Tiểu mục 1052</Th>
              <Th style={{ textAlign: "center" }}>Tiểu mục 1056</Th>
              <Th style={{ textAlign: "center" }}>Tiểu mục 1057</Th>
              <Th style={{ textAlign: "center" }}>Tiểu mục 1099</Th>
              <Th style={{ textAlign: "center" }}>Tiểu mục 1053</Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Thuế TNDN của hoạt động sản xuất kinh doanh"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"E1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="skkttk"
                  readonly="true"
                  value={dataB[0].value.skkttk}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="tm1052"
                  readonly="true"
                  value={dataB[0].value.tm1052}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="tm1056"
                  readonly="true"
                  value={dataB[0].value.tm1056}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="tm1057"
                  readonly="true"
                  value={dataB[0].value.tm1057}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="tm1099"
                  readonly="true"
                  value={dataB[0].value.tm1099}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Thuế TNDN của hoạt động chuyển nhượng bất động sản (E2=E3+E4)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"E2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={1}
                  name="skkttk"
                  readonly="true"
                  value={dataB[1].value.skkttk}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {" "}
                <InputTable
                  id={1}
                  name="tm1099"
                  readonly="true"
                  value={dataB[1].value.tm1099}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {
                  "Thuế TNDN phải nộp khác (nếu có) không bao gồm tiền lãi phải nộp khi xử lý quỹ KHCN"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {
                  "E5 - Tổng cột [13] mục III trên bảng kê 03-6 - Tổng cột [14] mục III trên bảng kê 03-6"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="skkttk"
                  readonly="true"
                  value={dataB[2].value.skkttk}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="tm1052"
                  readonly="true"
                  value={dataB[2].value.tm1052}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="tm1056"
                  readonly="true"
                  value={dataB[2].value.tm1056}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="tm1057"
                  readonly="true"
                  value={dataB[2].value.tm1057}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="tm1099"
                  readonly="true"
                  value={dataB[2].value.tm1099}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
            </tr>
            <tr key={3}>
              <Td
                colSpan={3}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Tổng cộng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={3}
                  name="tm1052"
                  readonly="true"
                  value={dataB[3].value.tm1052}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={3}
                  name="tm1056"
                  readonly="true"
                  value={dataB[3].value.tm1056}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={3}
                  name="tm1057"
                  readonly="true"
                  value={dataB[3].value.tm1057}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={3}
                  name="tm1099"
                  readonly="true"
                  value={dataB[3].value.tm1099}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={3}
                  name="tm1053"
                  readonly="true"
                  value={dataB[3].value.tm1053}
                  onChange={handleChangeB}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
